import './Navbar.css'

import ShoppingCart from '@material-ui/icons/ShoppingCart'
import SearchIcon from '@material-ui/icons/Search'
import IndianFlag from '../images/flags.png'
import LocationIcon from '@material-ui/icons/Room'
import { Link } from 'react-router-dom'


import { useSelector } from 'react-redux'

function Navbar() {


  return (


  
    <div className="navbar__1">
      <div><Link to="/"><p>ALL</p></Link></div>
      

      <div><Link to="/mobile"><p>Moblies</p></Link></div>

      <div><Link to="/pay"><p>Amazon Pay</p></Link></div>

      <div className="none"><Link to ="/dress"><p>Fashion </p></Link></div>

      <div className="none"><Link to ="/Order"><p>Computer</p></Link></div>

      <div className="none"><Link to="/chim"><p>Kitchen</p></Link></div>

      <div><Link to="/toy"><p>Toys & Games</p></Link></div>

    </div>


  )
}

export default Navbar;